import { useDispatch } from "react-redux";

import { selectLocale } from "common/shared-store/actions/locale";

export default function useLocaleSetter(): (locale: string) => void {
  const dispatch = useDispatch();

  return (locale: string) => dispatch(selectLocale(locale));
}
